/* eslint-disable no-unused-vars */
import axios from "utils/httpClient";
import React, { useState, useEffect } from "react";
import { Collapse, Modal, ModalBody } from "reactstrap";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import "bootstrap/dist/css/bootstrap.min.css";
import CardFooter from "components/Card/CardFooter.js";
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import KeyboardIcon from '@material-ui/icons/Keyboard';
import Button from "components/CustomButtons/Button.js";
import Search from "@material-ui/icons/Search";
import CustomInput from "components/CustomInput/CustomInput.js";
import TSSelect from "components/Forms/TSSelect2";
import styles2 from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { width } from "@material-ui/system";
import { Save } from "@material-ui/icons";
import { Checkbox } from "@material-ui/core";

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none"
    },
    iconFile: {
        width: "32px",
        maxWidth: "100%"
    }
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

export default function VaccineMahidol(props) {
    // แก้ไข: != เป็น !==
    const VaccineEventKey = (props.match.params.VaccineEventKey !== undefined) ? props.match.params.VaccineEventKey : null;
    var moment = require('moment');
    require('moment/locale/th');

    const classes = useStyles();
    const classes2 = useStyles2();
    const [Search1, setSearch1] = useState([]);
    const [SerialNo, setSerialNo] = useState("");
    const [LotNo, setLotNo] = useState("");
    const [ExpiredDate, setExpiredDate] = useState("");
    const [name, setName] = useState("");
    const [lastName, setLastName] = useState("");
    const [EmployeeID, setEmployeeID] = useState("");
    const [SBP, setSBP] = useState(1);
    const [VaccineID, setVaccineID] = useState(null);
    const [DBP, setDBP] = useState(1);
    const [Temp, setTemp] = useState(null);
    const [PR, setPR] = useState(1);
    const [RR, setRR] = useState(null);
    const [Height, setHeight] = useState(null);
    const [Weight, setWeight] = useState(null);
    const [CheckColor, setCheckColor] = useState('white');

    const [lOption, setLOption] = useState([]);
    const [RiskOption, setRiskOption] = useState([]);
    //const [option, setOption] = useState(null)
    const [RiskGroup, setRiskGroup] = useState(null);
    const [Injector, setInjector] = useState(null);

    const [modal, setModal] = useState(false);
    const [isCheckPerson, setIsCheckPerson] = useState(false);
    const [isAutoSave, setIsAutosave] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [modalError, setModalError] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");

    const [FullName, setFullName] = useState("");



    useEffect(() => {
        const requestOptions = {
            method: "GET",
        };


        axios("/api/trs/injector", requestOptions)
            .then(response => response.data)
            .then(
                result => {
                    setLOption(result);
                },
                error => {
                    alert(error);
                }
            );


        axios("/api/vaccine/riskgroup", requestOptions)
            .then(response => response.data)
            .then(
                result => {
                    setRiskOption(result);
                },
                error => {
                    alert(error);
                }
            );
    }, []);


    useEffect(() => {

        // แก้ไข: != เป็น !==
        if (EmployeeID !== null && EmployeeID !== '' && SerialNo !== null && SerialNo !== '') {

            // แก้ไข: == เป็น ===
            if (Temp === null || Temp === '')
                document.getElementById("Temp").focus();
            // แก้ไข: == เป็น ===
            else if (Weight === null || Weight === '')
                document.getElementById("Weight").focus();
            else {
                if (isAutoSave && isCheckPerson)
                    document.getElementById("btnSubmit").focus();
                else
                    document.getElementById("Height").focus();
            }

        }

        // แก้ไข: เพิ่ม dependencies ที่ขาดหายไป
    }, [SerialNo, EmployeeID, Temp, Weight, isAutoSave, isCheckPerson]);


    const SendTab = (event, id) => {
        if (event.key === 'Enter') {
            // แก้ไข: != เป็น !==
            if (id !== "btnSubmit")
                document.getElementById(id).focus();
            // แก้ไข: == เป็น ===
            else if (id === "btnSubmit" && isCheckPerson)
                document.getElementById(id).focus();
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            //setCheckColor('white');

            var isCall = false;


            // แก้ไข: == เป็น ===
            if (Search1.length === 5 || Search1.length === 13) {
                // 5 หรือ 13 หลัก ให้ค้นชื่อ
                isCall = true;

            }
            // แก้ไข: == เป็น ===
            else if (Search1.length === 20) {
                setSerialNo(Search1);

                // แก้ไข: == เป็น ===
                isCall = (EmployeeID === null || EmployeeID === '');

                setSearch1('');
            }
            // แก้ไข: == เป็น ===
            else if (Search1.length === 0) {
                isCall = false;
                document.getElementById("btnSubmit").focus();

            }

            if (isCall) {

                const requestOptions = {
                    method: "GET"
                };

                axios("/api/trs/mahidol/" + VaccineEventKey + "/" + Search1, requestOptions)
                    .then(response => response.data)
                    .then(
                        result => {

                            setFullName(result.titleName + ' ' + result.firstName + ' ' + result.lastName);
                            setEmployeeID(result.employeeID);
                            /*
                            if (result.employeeID == '3929800028214')
                            {
                                setCheckColor('blue');
                                alert('blue')
                            }
                            else {
                                setCheckColor('green');
                            }
                            */

                            // แก้ไข: == เป็น ===
                            if (result.trsVaccineID === null || result.trsVaccineID === '' || result.trsVaccineID === '00000000-0000-0000-0000-000000000000') {
                                setVaccineID('00000000-0000-0000-0000-000000000000');
                            }
                            else {
                                setVaccineID(result.trsVaccineID);
                            }

                            // แก้ไข: != เป็น !==
                            if (result.serialNo !== null && result.serialNo !== '') {
                                setSerialNo('');
                                setSerialNo(result.serialNo);
                            }
                            else {
                                setSerialNo('');
                            }

                            setTemp(result.temp);
                            setHeight(result.height);
                            setWeight(result.weight);

                            // แก้ไข: == เป็น ===
                            (result.temp === null || result.temp === '') ? setTemp('') : setTemp(result.temp);
                            // แก้ไข: == เป็น ===
                            (result.height === null || result.height === '') ? setHeight('') : setHeight(result.height);
                            // แก้ไข: == เป็น ===
                            (result.weight === null || result.weight === '') ? setWeight('') : setWeight(result.weight);

                            // แก้ไข: == เป็น ===
                            (result.systolicBP === null || result.systolicBP === '') ? setSBP(1) : setSBP(result.systolicBP);
                            // แก้ไข: == เป็น ===
                            (result.diastolicBP === null || result.diastolicBP === '') ? setDBP(1) : setDBP(result.diastolicBP);
                            // แก้ไข: == เป็น ===
                            (result.PR === null || result.PR === '') ? setPR(1) : setPR(result.PR);


                            if (!isCheckPerson) {
                                setRiskGroup(result.riskGroupKey);
                                setInjector(result.injectorKey);
                            }

                            setSearch1('');


                        },
                        error => {
                            //setCheckColor('orange');
                            //setIsAutoSave(true);
                            //alert("ไม่มีข้อมูลผู้ฉีดวัคซีน");
                            setFullName('');
                            setEmployeeID('');
                            setVaccineID('00000000-0000-0000-0000-000000000000');
                            //setSerialNo('');
                            setLotNo('');
                            setExpiredDate('')
                            setHeight('');
                            setWeight('');
                            setTemp('');
                            setSBP(1);
                            setDBP(1);
                            setPR(1);
                            setRR('');
                            if (!isCheckPerson) {
                                setRiskGroup(0);
                                setInjector(0);
                            }

                            setSearch1('');

                        }
                    );
            }

        }
    }

    const handleSearch = (e) => {
        console.log(e);

    };

    const handleSubmit = evt => {
        evt.preventDefault();
        var cntErr = 0;

        var txtErr = 'กรุณา\r\n';
        //if (isAutoSave) {

        // แก้ไข: == เป็น ===
        if (SerialNo === null || SerialNo === '') {
            txtErr += 'ระบุ Serial No.\r\n';
            cntErr += 1;
        }
        // แก้ไข: == เป็น ===
        if (EmployeeID === null || EmployeeID === '') {
            txtErr += 'ค้นหาบุคคล\r\n';
            cntErr += 1;
        }
        // แก้ไข: == เป็น ===
        if (Injector === null || Injector === '' || Injector === 0) {
            txtErr += 'ระบุผู้ฉีด\r\n';
            cntErr += 1;
        }
        // แก้ไข: == เป็น ===
        if (Temp === null || Temp === '') {
            txtErr += 'ระบุอุณหภูมิ\r\n';
            cntErr += 1;
        }
        // แก้ไข: == เป็น ===
        if (SBP === null || SBP === '') {
            txtErr += 'ระบุความดัน SBP\r\n';
            cntErr += 1;
        }
        // แก้ไข: == เป็น ===
        if (DBP === null || DBP === '') {
            txtErr += 'ระบุความดัน DBP\r\n';
            cntErr += 1;
        }
        // แก้ไข: == เป็น ===
        if (PR === null || PR === '') {
            txtErr += 'ระบุ PR\r\n';
            cntErr += 1;
        }
        // แก้ไข: == เป็น ===
        if (Weight === null || Weight === '') {
            txtErr += 'ระบุน้ำหนัก\r\n';
            cntErr += 1;
        }
        // แก้ไข: == เป็น ===
        if (Height === null || Height === '') {
            txtErr += 'ระบุส่วนสูง\r\n';
            cntErr += 1;
        }

        if (cntErr > 0) {
            alert(txtErr);
        } else {
            //setModal(true);
            handleConfirm();
        }
    };
    const handleClear = evt => {
        setFullName('');
        setEmployeeID('');
        setSearch1('');
        setVaccineID('00000000-0000-0000-0000-000000000000');
        setSerialNo('');
        setLotNo('');
        setExpiredDate('')
        setHeight('');
        setWeight('');
        setTemp('');
        setSBP(1);
        setDBP(1);
        setPR(1);
        setRR('');
        if (!isCheckPerson) {
            setInjector(0);
            setRiskGroup(0);
        }
    };
    const isCheck = () => {

    };

    const handleConfirm = (/*evt*/) => {
        //evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json"
            },
            data: {
                // แก้ไข: != เป็น !==
                trsVaccineID: (VaccineID !== null) ? VaccineID : '00000000-0000-0000-0000-000000000000',
                employeeID: EmployeeID,
                vaccineEventKey: VaccineEventKey,
                serialNo: SerialNo,
                lotNo: LotNo,
                expiredDate: ExpiredDate,
                height: Height,
                weight: Weight,
                temp: Temp,
                pr: PR,
                systolicBP: SBP,
                diastolicBP: DBP,
                rr: RR,
                injectorKey: Injector,
                riskGroupKey: RiskGroup,
                lastEditDT: moment().format("YYYY-MM-DD hh:mm:ss")
            }
        };

        axios("/api/trs/vaccine/", requestOptions)
            .then(response => response.data)
            .then(
                result => {
                    alert(JSON.stringify(result));
                    //window.location.href = '/admin/vaccine';

                    setModal(false);
                    setIcon("far fa-question-circle");

                    setFullName('');
                    setEmployeeID('');
                    setSearch1('');
                    setVaccineID('00000000-0000-0000-0000-000000000000');
                    setSerialNo('');
                    setLotNo('');
                    setExpiredDate('')
                    setHeight('');
                    setWeight('');
                    setTemp('');
                    setSBP(1);
                    setDBP(1);
                    setPR(1);
                    setRR('');
                    if (!isCheckPerson) {
                        setInjector(0);
                        setRiskGroup(0);
                    }


                    document.getElementById("txtSearch").focus();
                },
                error => {
                    alert('ไม่สามารถบันทึกได้')
                    setFullName('');
                    setEmployeeID('');
                    setSearch1('');
                    setVaccineID('00000000-0000-0000-0000-000000000000');
                    setSerialNo('');
                    setLotNo('');
                    setExpiredDate('')
                    setHeight('');
                    setWeight('');
                    setTemp('');
                    setSBP(1);
                    setDBP(1);
                    setPR(1);
                    setRR('');
                    if (!isCheckPerson) {
                        setInjector(0);
                        setRiskGroup(0);
                    }

                    alert(error);
                    setModal(false);
                    setIcon("far fa-question-circle");
                }
            );
    };


    return (
        <div style={{ backgroundColor: CheckColor }}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12} >
                    <Card>
                        <CardHeader color="warning" stats icon>
                            <h4 style={{ color: 'black' }}> Scan Serial Number, หรือ Scan QRCode ใบนำทางก่อนก็ได้ (หรือ Key เลขบัตร 13 หลัก, ลำดับ 5 หลัก) </h4>
                            <CardIcon color="info">
                                <Icon>
                                    <KeyboardIcon />
                                </Icon>
                            </CardIcon>
                            <div className={classes.searchWrapper} xs={12} sm={12} md={12}>
                                <CustomInput
                                    labelText="Scan"
                                    formControlProps={{
                                        style: { width: '400px' },
                                        fullWidth: false
                                    }}
                                    id="txtSearch"
                                    onChange={e => setSearch1(e)}
                                    value={Search1}
                                    onKeyDown={handleKeyDown}
                                />
                                <Button
                                    color="white"
                                    aria-label="edit"
                                    justIcon
                                    round
                                    onClick={() => handleSearch()}
                                >
                                    <Search />
                                </Button>
                            </div>
                        </CardHeader>

                        <CardBody>
                            <GridContainer>
                                {/*
            <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                    labelText="ชื่อ"
                    id="name"
                    formControlProps={{
                        fullWidth: true
                    }}
                    onChange={e => setName(e)}
                    value={name}
                />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                    labelText="นามสกุล"
                    id="lastName"
                    formControlProps={{
                        fullWidth: true
                    }}
                    onChange={e => setLastName(e)}
                    value={lastName}
                />
                              </GridItem>
*/}
                                <GridItem xs={12} sm={12} md={12}>
                                    <h3 className={classes2.cardTitle} >
                                        ชื่อ : {EmployeeID} {FullName}
                                    </h3>
                                    <h3 className={classes2.cardTitle} >
                                        Serial No : {SerialNo}
                                    </h3>
                                </GridItem>

                                <GridItem style={{ display: 'none' }} xs={12} sm={4} md={4}>
                                    Lot No.
                                    <CustomInput
                                        //labelText="Lot No."
                                        id="lotNo"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        onChange={e => setLotNo(e)}
                                        value={LotNo}
                                    />
                                </GridItem>
                                <GridItem style={{ display: 'none' }} xs={12} sm={4} md={4}>
                                    Expired
                                    <CustomInput
                                        //labelText="Expired"
                                        id="expiredDate"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        onChange={e => setExpiredDate(e)}
                                        value={ExpiredDate}
                                    />
                                </GridItem>

                                <GridItem xs={12} sm={4} md={4}>
                                    SBP
                                    <CustomInput
                                        //labelText="SBP"
                                        id="SBP"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        onChange={e => setSBP(e)}
                                        value={SBP}
                                        integerNumber={true}
                                        onKeyDown={e => SendTab(e, "DBP")}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={4} md={4}>
                                    DBP
                                    <CustomInput
                                        //labelText="DBP"
                                        id="DBP"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        onChange={e => setDBP(e)}
                                        value={DBP}
                                        integerNumber={true}
                                        onKeyDown={e => SendTab(e, "PR")}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={4} md={4}>
                                    PR
                                    <CustomInput
                                        //labelText="PR"
                                        id="PR"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        onChange={e => setPR(e)}
                                        value={PR}
                                        integerNumber={true}
                                        onKeyDown={e => SendTab(e, "Weight")}
                                    />
                                </GridItem>

                                <GridItem style={{ display: 'none' }} xs={6} sm={3} md={3}>
                                    RR
                                    <CustomInput
                                        //labelText="RR"
                                        id="RR"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        onChange={e => setRR(e)}
                                        value={RR}
                                        integerNumber={true}
                                    />
                                </GridItem>

                                <GridItem xs={12} sm={4} md={4}>
                                    Temp
                                    <CustomInput
                                        //labelText="Temp"
                                        id="Temp"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        onChange={e => setTemp(e)}
                                        value={Temp}
                                        numericInput={true}
                                        onKeyDown={e => SendTab(e, "Weight")}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={4} md={4}>
                                    Weight
                                    <CustomInput
                                        //labelText="Weight"
                                        id="Weight"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        onChange={e => setWeight(e)}
                                        value={Weight}
                                        numericInput={true}
                                        onKeyDown={e => SendTab(e, "Height")}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={4} md={4}>
                                    Height
                                    <CustomInput
                                        //labelText="Height"
                                        id="Height"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        onChange={e => setHeight(e)}
                                        value={Height}
                                        numberOnly={true}
                                        onKeyDown={e => SendTab(e, "btnSubmit")}
                                    />
                                </GridItem>


                                <GridItem xs={12} sm={4} md={4}>
                                    <TSSelect label="กลุ่มเสี่ยง" options={/*urgentList*/RiskOption} value={RiskGroup} placeholder="ค้นหา" onChange={e => setRiskGroup(e.value)} />
                                </GridItem>




                                <GridItem xs={12} sm={4} md={4}>
                                    <TSSelect label="ผู้ฉีดวัคซีน" options={/*urgentList*/lOption} value={Injector} placeholder="ค้นหา" onChange={e => setInjector(e.value)} />
                                </GridItem>

                                <GridItem xs={12} sm={4} md={4}>
                                    <input type="checkbox"
                                        onChange={() => setIsCheckPerson(!isCheckPerson)}
                                    /> ไม่เปลี่ยนผู้ฉีด  {Injector}


                                    <input type="checkbox"
                                        onChange={() => setIsAutosave(!isAutoSave)}
                                    /> บันทึกหลัง Scan
                                </GridItem>


                            </GridContainer>
                            <GridContainer style={{ backgroundColor: CheckColor }}>
                                <GridItem style={{ marginTop: "20px" }} xs={12} sm={6} md={6}>
                                    <Button color="primary" onClick={handleSubmit} id="btnSubmit">
                                        <h4>บันทึก</h4>
                                    </Button>
                                </GridItem>
                                <GridItem style={{ marginTop: "20px", display: 'none' }} xs={12} sm={6} md={6}>
                                    <Button color="primary" onClick={handleClear}>
                                        <h4>Clear</h4>
                                    </Button>
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        <CardFooter>

                            {/* Confirm */}
                            <Modal toggle={() => setModal(false)} isOpen={modal}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={() => setModal(false)}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button>

                                    <Button
                                        color="primary"
                                        type="button"
                                        onClick={handleConfirm}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <h4>ยืนยัน</h4>
                                    </Button>
                                </div>
                            </Modal>
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}